module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAADYSURBVHgB7ZC9EYJAEIWPnSG3BFqwA+lAK9CIn0isQKhAjRgg0A4oQTrQEiiBAvjxLXMBc3IYEJjwZm7Yu3377S5CLPqf4jg+/PIkSbJV32h4SdP0SUT3LMvOOojM5WhYaEFN00T8bds2RNdAhaDRkXN9IdF1mDPE99gMuEig7ft+MVgnl7aT67rTIBbGDtGRV6jqurYRVzgv3FeAR4CHas0oSMIeKN4jLOWT1XXdzfO8YMyvBbH456N40xsN4+04zlrnpSmQaZo7OVGJ2BZzhBUtPmLRbH0AsxdRBQIyqA8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/userDown.png
// module id = qgrb
// module chunks = 58